import { render } from "./RememberList.vue?vue&type=template&id=d84107d8&ts=true"
import script from "./RememberList.vue?vue&type=script&lang=ts"
export * from "./RememberList.vue?vue&type=script&lang=ts"

import "./RememberList.vue?vue&type=style&index=0&id=d84107d8&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__